import React, { useState } from 'react';
import { useFormik } from 'formik';
// import * as Yup from 'yup';
import * as XLSX from 'xlsx';

import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { CardBody, Form } from 'react-bootstrap';
import { getAllFingerPrintList } from '../../../../store/HR/Raqeeb/raqeebSlice';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card } from '../../../../components/card/card';
import useGetRotationPlan from '../../../../hooks/HR/use-get-RotationPlan';
import useGetPersons from '../../../../hooks/HR/use-get-persons';
import NtxTable from '../../../../components/DataTable/NtxTable';

const FingerPrintEmpTime = () => {
  const [data, setData] = useState([]); //
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { loading, RotationPlanOptions } = useGetRotationPlan();
  const { dataEmployees } = useGetPersons();

  const formik = useFormik({
    initialValues: {
      dateFrom: '',
      dateTo: '',
      rotationPlanId: null,
      personId: null,
    },
    onSubmit: async (values) => {
      try {
        // إعادة تعيين البيانات
        setData([]);

        // إرسال الطلب
        const res = await dispatch(
          getAllFingerPrintList({
            DateFrom: values.dateFrom,
            DateTo: values.dateTo,
            RotationPlanId: values.rotationPlanId,
            PersonId: values.personId,
          })
        ).unwrap();

        // معالجة الاستجابة
        if (res?.succeeded) {
          if (res.data.length === 0) {
            CustomAlert({ action: 'info', msg: t('NoData') });
          } else {
            setData(res.data);
          }
        } else {
          CustomAlert({ action: 'Error', msg: res?.message });
        }
      } catch (error) {
        // معالجة الأخطاء
        CustomAlert({ action: 'Error', msg: error.message || t('SomethingWentWrong') });
      } finally {
        // إيقاف حالة التحميل
        formik.setSubmitting(false);
      }
    },
  });

  const columns = [
    { title: t('EmployeeName'), key: 'Name', className: 'w-25' },
    { title: t('EmployeeNumber'), key: 'No', className: 'w-25' },
    { title: t('Date'), key: 'Date', className: 'w-25' },
    { title: t('Time'), key: 'Time', className: 'w-25' },
  ];

  const tableData = data?.map((item) => {
    let rowClass;

    const dateTime = item.transactionDateTime;
    const [date, time] = dateTime.split(' ');

    const personName = dataEmployees.find((f) => f.employeeNumber === item.empNumber)?.label;

    return {
      Name: personName,
      No: item.empNumber,
      Date: date,
      Time: time,
      rowClass, // استخدم rowClass هنا
    };
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const exportToExcel = (data) => {
    // تخصيص البيانات لاستخراج الأعمدة المطلوبة فقط
    const customizedData = data.map((item) => ({
      EmployeeName: item.Name,
      EmployeeNumber: item.No,
      Date: item.Date, // يمكنك تنسيق التاريخ هنا إذا لزم الأمر
      Time: item.Time, // يمكنك تنسيق الوقت هنا إذا لزم الأمر
    }));

    // إنشاء ورقة العمل من البيانات المخصصة
    const worksheet = XLSX.utils.json_to_sheet(customizedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // تنزيل الملف
    XLSX.writeFile(workbook, `${'FingerPrintData'}.xlsx`);
  };

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
           link: ':moduleHome',
          },
          {
            name: t('FingerprintData'),
            link: null,
          },
        ]}
        PageName="FingerprintData"
      />

      <Card>
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <div className="row ">
              <div className="col-xl-4">
                <div className="row ">
                  <div className="col-xl-12">
                    <div className="input-group mb-3 ">
                      <span className="input-group-text">{t('From')}</span>
                      <Form.Control
                        className="form-control text-center"
                        type="date"
                        name="dateFrom"
                        onChange={formik.handleChange}
                        value={formik.values.dateFrom}
                        // isInvalid={!!formik.errors.dateFrom}
                      />
                    </div>
                  </div>

                  <div className="col-xl-12">
                    <div className="input-group mb-3">
                      <span className="input-group-text">{t('To')}</span>
                      <Form.Control
                        className="form-control text-center"
                        type="date"
                        name="dateTo"
                        onChange={formik.handleChange}
                        value={formik.values.dateTo}
                        // isInvalid={!!formik.errors.dateTo}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-8">
                <div className="row ">
                  <div className="col-xl-12">
                    <div className={`input-group flex-nowrap mb-3   `}>
                      <span className="input-group-text  fw-bold">{t('RotationPlan')}</span>
                      <Select
                        // isDisabled={mode === 'All' || mode === 'Emp'}
                        classNamePrefix="react-select"
                        className="w-100"
                        isLoading={loading}
                        isSearchable={true}
                        isClearable
                        options={RotationPlanOptions}
                        value={
                          formik.values.rotationPlanId === null
                            ? null
                            : RotationPlanOptions?.find(
                                (f) => f.value === formik.values.rotationPlanId
                              )
                        }
                        onChange={(option) => {
                          formik.setFieldValue(
                            'rotationPlanId',
                            option === null ? null : option.value
                          );
                        }}
                        placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      />
                    </div>
                  </div>

                  <div className="col-xl-12">
                    <div className={`input-group flex-nowrap mb-3  `}>
                      <span className="input-group-text  fw-bold">{t('Employee')}</span>
                      <Select
                        // isDisabled={mode === 'All' || mode === 'RotationPlan'}
                        classNamePrefix="react-select"
                        className="w-100"
                        isLoading={loading}
                        isSearchable={true}
                        isClearable
                        name="personId"
                        options={dataEmployees}
                        value={
                          formik.values.personId === null
                            ? null
                            : dataEmployees?.find((f) => f.value === formik.values.personId)
                        }
                        onChange={(option) => {
                          formik.setFieldValue('personId', option === null ? null : option.value);
                        }}
                        placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        formatOptionLabel={(option) => (
                          <div className="d-flex justify-content-between   ">
                            <div className="">{option.label}</div>
                            <div className="text-theme fw-bold">{option.employeeNumber}</div>
                          </div>
                        )}
                        filterOption={(candidate, inputValue) => {
                          // البحث في الاسم أو رقم الموظف
                          const searchValue = inputValue.toLowerCase();
                          const labelMatches = candidate?.label
                            ?.toLowerCase()
                            ?.includes(searchValue);
                          const numberMatches = candidate?.data?.employeeNumber
                            ?.toLowerCase()
                            .includes(searchValue);
                          return labelMatches || numberMatches;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4">
                <div className="form-group mb-3 d-flex justify-content-end">
                  <button
                    // disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
                    type="submit"
                    className="btn me-1 btn-theme w-100">
                    {formik.isSubmitting ? (
                      <div className="spinner-border spinner-border-sm me-2"></div>
                    ) : (
                      <i className="bi bi-repeat fa-fw me-2"></i>
                    )}
                    {t('Show')}
                  </button>
                </div>
              </div>
              <div className="col-xl-8">
                <div className="d-flex justify-content-end mb-3">
                  <button
                    disabled={tableData.length === 0}
                    onClick={() => exportToExcel(tableData, 'FingerPrintData')}
                    className="btn btn-success">
                    <i className="fas fa-file-excel me-2"></i>
                    {t('ExportData')}
                  </button>
                </div>
              </div>
            </div>
          </Form>

          <div className=" bg-theme bg-opacity-5 rounded-1">
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default FingerPrintEmpTime;
